import store from '@/store'
if (localStorage.getItem('favorites_sessions')) {
  store.commit('setFavoriteSessions', JSON.parse(localStorage.getItem('favorites_sessions')));
} else {
  localStorage.setItem('favorites_sessions', JSON.stringify([]));
}
if (localStorage.getItem('favorites_presentations')) {
  store.commit('setFavoritePresentations', JSON.parse(localStorage.getItem('favorites_presentations')));
} else {
  localStorage.setItem('favorites_presentations', JSON.stringify([]));
}